(function () {

  var style = document.createElement('style');
  style.textContent = [
    '.product-add-to-cart-container { position: relative !important; }',
    '.product-card--add-to-cart-button-wrapper { position: relative !important; }',
    '.atc-notification {',
    '  display: flex;',
    '  align-items: center;',
    '  gap: 8px;',
    '  background: #fff;',
    '  border: 1px solid #e0e0e0;',
    '  border-radius: 6px;',
    '  padding: 10px 14px;',
    '  box-shadow: 0 2px 8px rgba(0,0,0,0.12);',
    '  white-space: nowrap;',
    '  width: max-content;',
    '  z-index: 99999;',
    '  opacity: 0;',
    '  transition: opacity 0.25s ease, transform 0.25s ease;',
    '  pointer-events: none;',
    '}',
    '.atc-notification.show {',
    '  opacity: 1;',
    '  pointer-events: auto;',
    '}',
    '.atc-notification__icon {',
    '  flex-shrink: 0;',
    '  display: flex;',
    '  align-items: center;',
    '}',
    '.atc-notification__text {',
    '  font-size: 14px;',
    '  color: #1a1a1a;',
    '  flex: 1;',
    '}',
    '.atc-notification__link {',
    '  font-size: 13px;',
    '  color: #1a1a1a;',
    '  text-decoration: underline;',
    '  text-underline-offset: 2px;',
    '  white-space: nowrap;',
    '}'
  ].join('\n');
  document.head.appendChild(style);

  function createNotification() {
    var lang = document.documentElement.lang || 'zh';
    var isEn = lang.toLowerCase().startsWith('en');
    var msgText = isEn ? 'Added to cart' : '成功加到購物車';
    var msgLink = isEn ? 'Checkout ›' : '前往付款 ›';

    var el = document.createElement('div');
    el.className = 'atc-notification';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.innerHTML =
      '<span class="atc-notification__icon">' +
        '<svg width="16" height="16" viewBox="0 0 16 16" fill="none">' +
          '<circle cx="8" cy="8" r="7" stroke="#3a7d44" stroke-width="1.5"/>' +
          '<path d="M4.5 8l2.5 2.5 4.5-4.5" stroke="#3a7d44" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</span>' +
      '<span class="atc-notification__text">' + msgText + '</span>' +
      '<a href="/cart" class="atc-notification__link">' + msgLink + '</a>';
    return el;
  }

function showNotification(button) {
    if (!button) return;

    // 移除舊的通知
    var existing = document.querySelector('.atc-notification');
    if (existing) existing.remove();

    // 計算 button 位置
    var rect = button.getBoundingClientRect();
    var viewportWidth = window.innerWidth;

    var notification = createNotification();

    // fixed 定位，貼在 button 正上方
    notification.style.position = 'fixed';
    notification.style.top = (rect.top - 8) + 'px';
    notification.style.transform = 'translateY(-100%)';
    notification.style.zIndex = '99999';

    document.body.appendChild(notification);

    // 插入後計算實際寬度，再決定 left
    var notifWidth = notification.getBoundingClientRect().width;
    var leftPos = rect.left;

    // 限制最大寬度為按鈕寬度
    var notifWidth = notification.getBoundingClientRect().width;
    var leftPos = rect.left;
    if (leftPos + notifWidth > viewportWidth - 8) {
      leftPos = viewportWidth - notifWidth - 8;
    }
    if (leftPos < 8) leftPos = 8;
    notification.style.left = leftPos + 'px';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        notification.classList.add('show');
      });
    });

    setTimeout(function () {
      notification.classList.remove('show');
      setTimeout(function () {
        if (notification.parentNode) notification.remove();
      }, 300);
    }, 5000);
  }


  document.addEventListener('atc:success', function (e) {
    var button = e.detail && e.detail.button;
    if (button) showNotification(button);
  });

  document.addEventListener('cart:item-added', function (e) {
    var button = document.querySelector('#AddToCart') || document.querySelector('[name="add"]');
    if (button) showNotification(button);
  });

})();
